class MenuMobile {
    // 1. describe and create/initiate our object
    constructor() {
        this.hasChildrenLinksMobile = document.querySelectorAll('.menu-mobile a.has-children');
        this.hasChildrenItemsMobile = document.querySelectorAll('.menu-mobile li.has-children');
        this.hamburger = document.querySelector('.menu-mobile--hamburger');
        this.hamburgerClose = document.querySelector('.menu-mobile--close');
        this.mobileMenu = document.querySelector('.menu-mobile');
        this.firstClick = true;

        if (this.hasChildrenItemsMobile && this.hasChildrenLinksMobile && this.hamburger && this.hamburgerClose && this.mobileMenu) {
            this.submenusMobile = document.querySelectorAll('.submenu');
            if (this.submenusMobile) {
                this.events();
            }
        }


    }

    // 2. events
    events() {
        this.hasChildrenItemsMobile.forEach(item => {
            item.addEventListener("click", (e) => {
                if (this.firstClick) {
                    e.preventDefault();
                    item.classList.add('clicked');
                    this.firstClick = false;
                }

                const mobileSubmenu = item.querySelector('.submenu-mobile');
                mobileSubmenu.classList.add('opened');
            })
        });

        this.hamburger.addEventListener('click', () => {
            this.mobileMenu.classList.add('opened');
            this.hamburger.classList.add('hidden');
            this.hamburgerClose.classList.remove('hidden');
        });
        this.hamburgerClose.addEventListener('click', () => {
            this.mobileMenu.classList.remove('opened');
            this.hamburger.classList.remove('hidden');
            this.hamburgerClose.classList.add('hidden');

            this.openedElements = this.mobileMenu.querySelectorAll('.menu-mobile__item.clicked');
            this.openedSubmenus = this.mobileMenu.querySelectorAll('.submenu-mobile.opened');
            if (this.openedElements) {
                this.openedElements.forEach(element => {
                    element.classList.remove('clicked');
                });
            }
            if (this.openedSubmenus) {
                this.openedSubmenus.forEach(element => {
                    element.classList.remove('opened');
                });
            }
            this.firstClick = true;
        });

        document.addEventListener('click', (e) => {
            if (!this.mobileMenu.contains(e.target) && !this.hamburger.contains(e.target) && !this.hamburgerClose.contains(e.target)) {
                this.mobileMenu.classList.remove('opened');
                this.hamburger.classList.remove('hidden');
                this.hamburgerClose.classList.add('hidden');
    
                this.openedElements = this.mobileMenu.querySelectorAll('.menu-mobile__item.clicked');
                this.openedSubmenus = this.mobileMenu.querySelectorAll('.submenu-mobile.opened');
                if (this.openedElements) {
                    this.openedElements.forEach(element => {
                        element.classList.remove('clicked');
                    });
                }
                if (this.openedSubmenus) {
                    this.openedSubmenus.forEach(element => {
                        element.classList.remove('opened');
                    });
                }
                this.firstClick = true;
            }
        })
    }

    // 3. methods (function, action...)

}

export default MenuMobile;
